import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogContentText, Typography, Paper, Button, InputBase, DialogActions } from '@mui/material';
import Avatar from '@mui/material/Avatar';
import '../SpeedDial.css';
import { getAvatarUrl } from '../../../utils/getAvatarUrl';

export default function PermissionsMenu({
    filteredMembers,
    boardMembers,
    username,
    handleRemovePermission,
    handleUpdatePermission,
    searchTerm,
    handleSearchChange,
    handlePermissaoDialogClose
}) {



    return (
        <div>
            <Dialog
                open={true}
                onClose={handlePermissaoDialogClose}
                maxWidth="lg"
                fullWidth
                BackdropProps={{
                    sx: {
                        backdropFilter: 'blur(5px)',
                        backgroundColor: 'rgba(0,0,0,0.3)',
                    }
                }}
                PaperProps={{
                    sx: {
                        maxHeight: '600px',
                        minHeight: '450px',
                        width: '850px',
                        m: 'auto',
                        display: 'flex',
                        flexDirection: 'column',
                    }
                }}
            >
            <DialogTitle className='text-navbar-options' style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: '23px', fontWeight: '700' }} id="help-dialog-title">Permissões dos Membros</DialogTitle>
            <DialogContent>
                <DialogContentText id="help-dialog-description" className='text-navbar-options'>
                    <div>
                        <Typography style={{ fontSize: '17px', marginBottom: '15px', marginLeft: '2px' }} gutterBottom>Edite as permissões dos membros participantes do quadro</Typography>
                        <div style={{ display: 'flex', justifyContent: 'flex-start' }}>
                            <div style={{ display: 'flex', maxWidth: '700px', flexWrap: 'wrap', gap: '15px', justifyContent: 'center' }}>
                                {filteredMembers.map((member) => {
                                    // Verifica se o membro está no quadro
                                    const isMemberInBoard = boardMembers.some(
                                        (boardMember) => parseInt(boardMember.user_id) === parseInt(member.userId)
                                    );

                                    // Obtém a permissão do membro no quadro
                                    const memberPermission = boardMembers.find(
                                        (boardMember) => parseInt(boardMember.user_id) === parseInt(member.userId)
                                    )?.permissao;

                                    // Verifica se a permissão é 'admin' ou 'dono'
                                    const isValidPermission = memberPermission === 'admin' || memberPermission === 'dono';

                                    return (
                                        member.Nome !== username &&
                                        isMemberInBoard && isValidPermission && (
                                            <Paper
                                                key={member.userId}
                                                elevation={3}
                                                style={{ maxWidth: '200px', minWidth: '200px', height: '120px', padding: '10px' }}
                                                className='div-admin'
                                            >
                                                <div style={{ display: 'flex', marginBottom: '8px' }}>
                                                    <Avatar src={getAvatarUrl(member.Nome)} style={{ width: '35px', height: '35px', marginTop: '5px' }} />
                                                    <span className='text-navbar-options' style={{ marginLeft: '5px', fontSize: '13px', marginTop: '5px' }}>
                                                        {member.nome_completo}
                                                    </span>
                                                </div>
                                                <div>
                                                    <span className='text-navbar-options' style={{ fontSize: '13px' }}>
                                                        <b style={{ color: '#009373', fontSize: '14px' }}>Permissão:</b> {memberPermission === 'admin' ? 'Admin' : memberPermission === 'dono' ? 'Dono' : 'Não atribuído'}
                                                    </span>
                                                </div>
                                                <div style={{ display: 'flex', justifyContent: 'end', marginTop: '15px' }}>
                                                    <Button
                                                        onClick={() => handleRemovePermission(member.userId)}
                                                        style={{ textTransform: 'none', border: 'none', borderRadius: '6px', padding: '10px', cursor: 'pointer', height: '30px !important', fontSize: '12px' }}
                                                        className='button-edit-options button-admin'
                                                    >
                                                        Remover admin
                                                    </Button>
                                                </div>
                                            </Paper>
                                        )
                                    );
                                })}
                            </div>
                        </div>
                        <Typography style={{ fontSize: '15px', marginBottom: '15px', marginTop: '25px', marginLeft: '2px' }} gutterBottom>Membros sem permissão:</Typography>
                        <Paper
                            component="form"
                            sx={{ p: '5px 4px', display: 'flex', alignItems: 'center', width: '800px' }}
                            className='search-bar'
                        >
                            <InputBase
                                sx={{ ml: 1, width: '100%' }}
                                placeholder="Buscar membros"
                                inputProps={{ 'aria-label': 'buscar cartão' }}
                                value={searchTerm}
                                onChange={handleSearchChange}
                                className='search-input'
                            />
                        </Paper>
                        <ul style={{ padding: '0px' }}>
                            {filteredMembers.map((member, index) => {
                                const isMemberInBoard = boardMembers.some((boardMember) => parseInt(boardMember.user_id) === parseInt(member.userId));

                                // Obtém a permissão do membro no quadro
                                const memberPermission = boardMembers.find(
                                    (boardMember) => parseInt(boardMember.user_id) === parseInt(member.userId)
                                )?.permissao;

                                // Verifica se a permissão é 'admin' ou 'dono'
                                const isValidPermission = memberPermission !== 'admin' && memberPermission !== 'dono';

                                return member.Nome !== username && isMemberInBoard && isValidPermission && (
                                    <li className='member-select2' key={index}>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                <Avatar src={getAvatarUrl(member.Nome)} style={{ width: '30px', height: '30px', marginTop: '5px' }} />
                                                <span style={{ marginLeft: '10px', fontSize: '14px' }}>{member.nome_completo}</span>
                                            </div>
                                            <div>
                                                <Button
                                                    onClick={() => handleUpdatePermission(member.userId)}
                                                    style={{ textTransform: 'none', border: 'none', borderRadius: '6px', padding: '10px', cursor: 'pointer', height: '30px', fontSize: '13px' }}
                                                    className='button-edit-options button-admin'
                                                >
                                                    Tornar admin
                                                </Button>
                                            </div>
                                        </div>
                                    </li>
                                );
                            })}
                        </ul>
                    </div>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={handlePermissaoDialogClose}
                    style={{ textTransform: 'none', border: 'none', borderRadius: '6px', padding: '10px', width: '100px', cursor: 'pointer', height: '40px' }}
                    className='button-navbar-options'
                >
                    Fechar
                </Button>
            </DialogActions>
            </Dialog>
        </div>
    );
}
